import { EMailSignature } from '@work4all/models/lib/Classes/EMailSignature.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { EntityTableV8, IEntityTableV8 } from './entity-table/EntityTableV8';
import { useEntityDataTableV8 } from './entity-table/use-entity-data-table-v8';
import schema from './schemata/eMailSignature-table-schema.json';

const defaultSort = [{ field: 'name', direction: SortDirection.ASCENDING }];

export function EMailSignatureTable(props: IEntityTableV8) {
  const dataTable = useEntityDataTableV8<EMailSignature, Record<string, never>>(
    {
      ...props,
      schema: schema as never,
      defaultSort,
    }
  );

  return <EntityTableV8 {...props} {...dataTable} />;
}
